import React, { useState, useEffect } from "react";
import { Container } from "@mui/material";
import ParticlesBg from "particles-bg";
import "../utils/collagestyles.css";
import NavMenu from "./Menu";
import { videosAtom } from "./atoms";
import axios from "axios";
import { useRecoilState } from "recoil";
import "react-lazy-load-image-component/src/effects/blur.css";
import ReactPlayer from "react-player/lazy";
//import './videos.css'

const CollagesVideo = () => {
  const [videos, setActiveVideos] = useRecoilState(videosAtom);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // get all videos by location in the bucket
        const resp = await axios.get("/getVideos");
        setActiveVideos(resp.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <NavMenu />
      <ParticlesBg type="circle" margin="5px" bg={true} />

      <Container align="center" maxWidth="sm">
        <h2>
          <p> Knight's Kennel </p>
        </h2>
          <div className="player-wrapper">
            <ReactPlayer
              url={videos[0]}
              className="react-player"
              playing={false}
              width="100%"
              height="100%"
              controls={true}
            />
          </div>
         
      </Container>
    </>
  );
};
export default CollagesVideo;
